import React from 'react';
import { motion } from 'framer-motion';
import { BuyButton } from './BuyButton';
export function HeroSection() {
  return <section className="relative pt-16 pb-20 md:pt-24 md:pb-32 overflow-hidden bg-[#FFF8F0]" data-id="element-47">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0" data-id="element-48">
        <div className="absolute -top-[20%] -right-[10%] w-[50%] h-[50%] rounded-full bg-pink-100/50 blur-3xl" data-id="element-49"></div>
        <div className="absolute top-[40%] -left-[10%] w-[40%] h-[40%] rounded-full bg-purple-100/50 blur-3xl" data-id="element-50"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-51">
        <div className="max-w-4xl mx-auto text-center" data-id="element-52">
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} className="text-4xl md:text-6xl font-bold text-purple-900 mb-8 leading-tight" data-id="element-53">
            ¿Por Qué Tu Quincena Muere el Día 3?
          </motion.h1>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="relative mx-auto max-w-md md:max-w-lg" data-id="element-54">
            <div className="absolute inset-0 bg-gradient-to-tr from-purple-500/20 to-pink-500/20 blur-2xl rounded-3xl transform rotate-3" data-id="element-55"></div>
            <img src="https://cdn.magicpatterns.com/uploads/dCvWEwRkVVWQkswmbpqaGx/COVER_N1.png" alt="Quincena Sin Ansiedad Cover" className="relative z-10 w-full h-auto rounded-xl shadow-2xl transform transition-transform hover:scale-[1.02] duration-500" data-id="element-56" />
          </motion.div>

          {/* CTA below product image */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.6
        }} className="mt-10 flex flex-col items-center gap-4" data-id="element-57">
            <p className="text-lg md:text-xl text-purple-800 font-semibold" data-id="element-58">
              Transforma tu relación con el dinero en solo{' '}
              <span className="text-pink-600" data-id="element-59">15 días</span>
            </p>
            <div className="flex items-center gap-3 mb-2" data-id="element-60">
              <span className="text-gray-400 line-through text-lg" data-id="element-61">$47.00</span>
              <span className="text-3xl font-bold text-purple-900" data-id="element-62">$9.97</span>
            </div>
            <BuyButton text="QUIERO MI RESET FINANCIERO →" data-id="element-63" />
            <p className="text-sm text-gray-500 mt-1" data-id="element-64">
              + 2 bonos gratis por tiempo limitado
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}